'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var index = require('./../../../external/classnames/index.js');
var index$1 = require('../../../utilities/GatsbyLink/index.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var ListenBlock = function ListenBlock(_ref) {
  var className = _ref.className,
    dividerBottom = _ref.dividerBottom,
    dividerTop = _ref.dividerTop,
    sources = _ref.sources;
  var classes = index.default('list-block', 'lanl-listen-block', dividerBottom && 'divider-bottom', dividerTop && 'divider-top', className);
  return /*#__PURE__*/React__default.default.createElement("div", {
    className: classes,
    "data-testid": "lanl-listen-block"
  }, /*#__PURE__*/React__default.default.createElement("h3", {
    className: "sidebar-header"
  }, "Download & Listen"), /*#__PURE__*/React__default.default.createElement("ul", {
    className: "list-block-ul list-unstyled"
  }, sources.map(function (_ref2, index) {
    var link = _ref2.link,
      name = _ref2.name;
    return /*#__PURE__*/React__default.default.createElement("li", {
      className: "list-block-li",
      key: "topic-list-".concat(name, "-").concat(index)
    }, /*#__PURE__*/React__default.default.createElement(index$1.default, {
      href: link
    }, name));
  })));
};
ListenBlock.defaultProps = {
  dividerBottom: true,
  dividerTop: true,
  sources: []
};
ListenBlock.propTypes = {
  className: PropTypes__default.default.string,
  dividerBottom: PropTypes__default.default.bool,
  dividerTop: PropTypes__default.default.bool,
  sources: PropTypes__default.default.array
};

exports.ListenBlock = ListenBlock;
exports.default = ListenBlock;
//# sourceMappingURL=ListenBlock.js.map
